import type { ErrorInfo, ReactNode } from "react";
import { Loads } from "../../client/index.ts";
import { Button } from "../../design/primitives/Button.tsx";
import { shellCopy } from "../copy.ts";
import styles from "./Errors.module.css";
import { errorText } from "@nabla/api";

const reported = new WeakSet<object>();

interface Props {
  readonly view: string;
  readonly report: (report: { message: string; stack?: string; view: string }) => void;
  readonly fallback?: ReactNode;
  readonly beside?: ReactNode;
  readonly children: ReactNode;
}

export function ErrorBoundary({ view, report, fallback, beside, children }: Props) {
  const reportOnce = (error: unknown, info: ErrorInfo) => {
    if (typeof error === "object" && error !== null) {
      if (reported.has(error)) return;
      reported.add(error);
    }
    const message = errorText(error).slice(0, 500);
    const stack = (error instanceof Error && error.stack ? error.stack : (info.componentStack ?? "")).slice(0, 4000);
    report({ message, ...(stack ? { stack } : {}), view: view.slice(0, 200) });
  };
  const broken = (reset: () => void) => (fallback !== undefined ? fallback : (
    <div>
      <p className={styles.title}>{shellCopy.tela.algoDeuErrado}</p>
      <div className={styles.actions}>
        <Button variant="primario" onClick={reset}>
          {shellCopy.tela.recarregarTela}
        </Button>
      </div>
    </div>
  ));
  return <Loads beside={beside} report={reportOnce} broken={broken}>{children}</Loads>;
}
